import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { config } from '../../constants/domainConfig';
import { searchText } from '../../actions/SearchActions';

import  { spanish } from "../../constants/spanish";
import { English } from "../../constants/english";
import { FormattedMessage } from 'react-intl';
import { getContactLinks } from '../../constants/contactLinks';


class BottomMobileMenu extends Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {
        this.toggleLinkActive();
    }

    componentDidUpdate() {
        this.toggleLinkActive();
    }

    toggleLinkActive() {
        let bottomMenuLink = document.querySelectorAll(".bottom-menu-link");
        bottomMenuLink.forEach(function(link) {
            if(link.href.indexOf(window.location.hash) !== -1) {
                link.classList.add("active");
                if(config.subDomain.includes('mobiofit')) link.classList.add('active-mobiofit');
            } else {
                link.classList.remove("active");
                if(config.subDomain.includes('mobiofit')) link.classList.remove('active-mobiofit');

            }
        });
    }
    toggleLangMenu(){
        this.setState({
            openLanguageMenu:!this.state.openLanguageMenu
        })
    }
    render() {
        let language;
        let showBottomMenu = this.props.showBottomMenu;
        if(config.language== 'spanish'){
            language = spanish;
        }
        else{
            language = English;
        }
        let uid = this.props.access.uid;
        const homeIconESMobile = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"><path fill="#7d7d7d" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></svg>';
        const searchIconESMobile = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle stroke="#7d7d7d" cx="11" cy="11" r="8"></circle><line stroke="#7d7d7d" x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>';
        const historyIconESMobile = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"><path fill="#7d7d7d" d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/></svg>';
        const accountIconESMobile = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 28 28"><path fill="#7d7d7d" d="M14 0c7.734 0 14 6.266 14 14 0 7.688-6.234 14-14 14-7.75 0-14-6.297-14-14 0-7.734 6.266-14 14-14zM23.672 21.109c1.453-2 2.328-4.453 2.328-7.109 0-6.609-5.391-12-12-12s-12 5.391-12 12c0 2.656 0.875 5.109 2.328 7.109 0.562-2.797 1.922-5.109 4.781-5.109 1.266 1.234 2.984 2 4.891 2s3.625-0.766 4.891-2c2.859 0 4.219 2.312 4.781 5.109zM20 11c0-3.313-2.688-6-6-6s-6 2.688-6 6 2.688 6 6 6 6-2.688 6-6z"></path></svg>';
        const photoIconSVG = '<svg width="24" height="24" viewBox="0 0 24 24" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" fill="#7d7d7d" stroke="#7d7d7d"><g id="SVGRepo_bgCarrier" stroke-width="0"/><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g id="SVGRepo_iconCarrier"><defs><style>.cls-1{fill:none;stroke:#7d7d7d;stroke-miterlimit:10;stroke-width:1.91px;}</style></defs><rect class="cls-1" x="1.5" y="1.5" width="21" height="21"/><polyline class="cls-1" points="1.5 19.64 8.18 12.96 13.91 18.68 17.73 14.86 22.5 19.64"/><circle class="cls-1" cx="13.91" cy="8.18" r="1.91"/></g></svg>'
        const cucaLink = getContactLinks(config.subDomain);
        return (
            <div>
                {showBottomMenu?
                    <div id="bottom-menu" className='bottom-menu'>
                    <nav>
                        <ul className='list-unstyled bottom-menu-navigate'>

                            <li className='bottom-menu-item'>
                                    <a className='bottom-menu-link' href={ `/#/home?uid=${uid}`} onClick={()=>this.props.searchText('')}>
                                    <span className="bottom-menu-icon-wrap">                            
                                        <span dangerouslySetInnerHTML={{__html: homeIconESMobile}}/>
                                    </span>
                                    <span>
                                            <FormattedMessage id="home"
                                                defaultMessage="Home"
                                            />
                                    </span>
                                </a>
                            </li>                        
                            <li className='bottom-menu-item'>
                                <a className='bottom-menu-link' href={`/#/search?uid=${uid}`} onClick={()=>this.props.searchText('')}>
                                    <span className="bottom-menu-icon-wrap">
                                        <span dangerouslySetInnerHTML={{__html: searchIconESMobile}}/>
                                    </span>
                                    <span>
                                            <FormattedMessage id="search"
                                                defaultMessage="Search"
                                            />
                                    </span>
                                </a>
                            </li>
                            <li className='bottom-menu-item'>
                                <a className='bottom-menu-link' href={`/#/history?uid=${uid}`} onClick={()=>this.props.searchText('')}>
                                    <span className="bottom-menu-icon-wrap">
                                        {/* <span className="bottom-menu-icon" dangerouslySetInnerHTML={{ __html: historyIcon }} />    */}                     
                                        {/* <img className="bottom-menu-icon__history" src="./img/history.svg" alt="history" /> */}
                                        <span dangerouslySetInnerHTML={{__html: historyIconESMobile}}/>                     
                                    </span>
                                    <span>
                                            <FormattedMessage id="history"
                                                defaultMessage="History"
                                            />
                                    </span>
                                </a>
                            </li>
                            <li className='bottom-menu-item'>
                                <a className='bottom-menu-link' href={`/#/account?uid=${uid}`} onClick={()=>this.props.searchText('')}>
                                    <span className="bottom-menu-icon-wrap">
                                        {/* <span className="bottom-menu-icon" dangerouslySetInnerHTML={{ __html: accountIcon }} />     */}                       
                                        {/* <img className="bottom-menu-icon__account" src="./img/account3.svg" alt="My Account" /> */}
                                        <span dangerouslySetInnerHTML={{__html: accountIconESMobile}}/>
                                    </span>
                                    <span><FormattedMessage id="myAcc"
                                            defaultMessage="My Account"
                                        />
                                    </span>
                                </a>
                            </li>
                            {config.subDomain === 'ae.mobiofit' && <li className='bottom-menu-item'>
                                <a className='bottom-menu-link' href={`https://my.appspool.net/en/photography/?type=apk&uid=${uid}`} onClick={()=>this.props.searchText('')} target="_blank">
                                    <span className="bottom-menu-icon-wrap">
                                        {/* <span className="bottom-menu-icon" dangerouslySetInnerHTML={{ __html: accountIcon }} />     */}                       
                                        {/* <img className="bottom-menu-icon__account" src="./img/account3.svg" alt="My Account" /> */}
                                        <span dangerouslySetInnerHTML={{__html: photoIconSVG}}/>
                                    </span>
                                    <span><FormattedMessage id="photographsApp"
                                            defaultMessage="Photo"
                                        />
                                    </span>
                                </a>
                            </li>}
                            {cucaLink && <li className='bottom-menu-item'>
                                <a className='bottom-menu-link' href={cucaLink} onClick={()=>this.props.searchText('')} target="_blank">
                                    <span className="bottom-menu-icon-wrap">
                                        <i className="fa fa-question" aria-hidden="true"></i>
                                    </span>
                                    <span><FormattedMessage id="help"
                                            defaultMessage="Contact Us"
                                        />
                                    </span>
                                </a>
                            </li>}
                        </ul>
                    </nav>
                </div>
                :
                ""
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        searchText
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(BottomMobileMenu);


// WEBPACK FOOTER //
// ./src/components/BottomMobileMenu/BottomMobileMenu.js